export default __webpack_public_path__ + "static/media/serbgo-screenshot-03.85dd28e2.png";